export default __webpack_public_path__ + "static/media/icons-add-white-18-px.ff8b0db6.svg";